<template>
  <button
    class="button"
    :class="classes"
    :type="type"
    :disabled="isLoading"
  >
    <div
      v-if="isLoading"
      class="button__loader"
    >
      <BaseLoaderDefault />
    </div>

    <div class="button__label">
      <slot></slot>
    </div>
  </button>
</template>

<script>
  import BaseLoaderDefault from '@/components/base/BaseLoaderDefault'

  export default {
    name: 'BaseButton',

    components: {
      BaseLoaderDefault
    },

    props: {
      type: {
        type: String,
        default: 'button'
      },
      skin: String,
      isLoading: Boolean
    },

    computed: {
      classes() {
        return {
          'button--loading': this.isLoading === true,
          'button--secondary': this.skin === 'secondary',
          'button--ai': this.skin === 'ai'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button {
    $color-primary: nth($colors-custom, 1);
    $color-secondary: nth($colors-custom, 2);

    position: relative;
    height: map-get($layout-insights, 'button-height');
    padding: 0 20px;
    border: 1px solid $color-primary;
    border-radius: 2em;
    transition: all 0.1s;
    background: $color-primary;
    color: #fff;
    font: {
      weight: 500;
      size: 14px;
    }

    &:disabled {
      opacity: 1;
    }

    &:hover {
      border-color: $color-secondary;
      background: $color-secondary;
      color: $color-primary;
    }

    &--loading & {
      &__label {
        visibility: hidden;
      }
    }

    &--secondary {
      border-color: $color-secondary;
      background: none;
      color: $color-secondary;

      &:hover {
        border-color: $color-primary;
        background: none;
        color: $color-primary;
      }
    }

    &--ai {
      $color-blue: nth($colors-custom, 1);
      $color-soft-blue: nth($colors-custom, 2);
      $color-gradient-green: rgba(203, 255, 0, 0.7);
      $color-gradient-blue: rgba(152, 193, 221, 0.7);

      height: map-get($layout-insights, 'button-small-height');

      color: $color-blue;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;

      border: 2px solid transparent;

      background: linear-gradient(94deg, $color-gradient-blue 2.73%, $color-gradient-green 103.24%);
      background-origin: border-box;

      &:hover {
        background: $color-soft-blue;
        border-color: $color-gradient-green;
      }
    }

    &__loader {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }
  }
</style>
